import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { saveAndContinueRehydrateSlice } from '../../../services/redux/storeUtils';
import { BetterBeWidgetPayload } from '../../../services/betterBe/betterBePayload.model';

export interface NewCarConfiguratorPageState {
  configurationResult: BetterBeWidgetPayload | null;
}

const initialState: NewCarConfiguratorPageState = {
  configurationResult: null,
};

const name = 'newCarConfiguratorPage';

export const slice = createSlice({
  name,
  initialState,
  reducers: {
    setConfigurationResult: (state, action: PayloadAction<BetterBeWidgetPayload | null>) => {
      state.configurationResult = action.payload;
    },
  },
  selectors: {
    configurationResult: (state) => {
      return state.configurationResult;
    },
  },
  extraReducers: (builder) => {
    saveAndContinueRehydrateSlice(builder, name);
  },
});

export const newCarConfiguratorPageSlice = slice;
export const newCarConfiguratorPageSliceSelectors = slice.selectors;
